/**
 *
 *
 * @class MobileMenu
 */
class MobileMenu {
    /**
     * Creates an instance of MobileMenu.
     * @param {string} mobMenuClass
     * @param {string} activeClass
     * @param {string} openButtonClass
    //  * @param {string} closeButtonClass
     * @memberof MobileMenu
     */
    constructor(mobMenuClass, activeClass, openButtonClass) {
        this.mobMenuClass = mobMenuClass;
        this.mobMenu = document.querySelector(mobMenuClass);
        this.activeClass = activeClass;
        this.openButtonClass = openButtonClass;
        this.openButton = document.querySelector(openButtonClass);
        // this.closeButton = document.querySelector(closeButtonClass);

        this.init();
    }    

    // closeOnBackdropClick = e => {
    //     if (e.target !== this.mobMenu && !e.target.closest(`${this.mobMenuClass}.${this.activeClass}`) && !e.target.closest(this.openButtonClass)) this.closeMenu();
    // }

    openMenu = () => {
        this.mobMenu.classList.add(this.activeClass);
        document.body.classList.add('lock');
        this.openButton.classList.add(this.activeClass);
        document.querySelector('.header').classList.add('mob-open');
        // document.addEventListener("click", this.closeOnBackdropClick);
    }

    closeMenu = () => {
        this.mobMenu.classList.remove(this.activeClass);
        document.body.classList.remove('lock');
        this.openButton.classList.remove(this.activeClass);
        document.querySelector('.header').classList.remove('mob-open');
        // document.removeEventListener("click", this.closeOnBackdropClick);
    }

    toggleMenu = () => {
        if (this.mobMenu.classList.contains(this.activeClass)) this.closeMenu() 
        else this.openMenu();
    }

    init = () => {
        this.openButton.addEventListener("click", this.toggleMenu);
        // this.closeButton.addEventListener("click", this.closeMenu);   
        
        window.matchMedia('(max-width: 960px').addEventListener('change', e => {
            if (!e.matches) return;
            if (this.openButton) {
                this.openButton.addEventListener("click", this.toggleMenu);
            }
        })
    
        window.matchMedia('(min-width: 961px)').addEventListener('change', (e) => {
            if (!e.matches) return;
            if (this.openButton) {
                this.openButton.removeEventListener("click", this.toggleMenu);
                this.openMenu();
                enableScroll();
            }
        })
    }
}

new MobileMenu('.mobile-menu', 'active', '.header__hamburger')



const header = document.querySelector('.header');

const shuffleHovers = Array.from(document.querySelectorAll('[data-hover-shuffle]'));

if (shuffleHovers.length > 0) {

    const shuffleAnimation = (e) => {
        const target = e.currentTarget;

        if (target.dataset.animating) return;
        
        if (target.dataset.hoverShuffle === 'children') {
            target.dataset.animating = true;
            
            target.style.width = `${target.offsetWidth}px`;
            // target.style.paddingInline = '0px'

            const words = target.querySelectorAll('[data-hover-shuffle-child]');
            const originalWords = Array.from(words).map((word) => word.textContent);
    
            let shuffles = 0;
            const maxShuffles = 3;
            const intervalDuration = 300 / maxShuffles;

    
            let animationInterval = setInterval(() => {
                if (shuffles >= maxShuffles) {
                    clearInterval(animationInterval);
                    words.forEach((word, index) => {
                        word.textContent = originalWords[index]
                    })
    
                    delete target.dataset.animating;                   
                    target.style.width = ``;
                } else {

                    words.forEach(word => {
                        let shuffledText = word.textContent.split('').sort(() => Math.random() - 0.5)
                        .join('');

                        word.textContent = shuffledText;
                    })
                    shuffles++;
                }
            }, intervalDuration)
        }
    }

    // if (window.matchMedia('(min-width: 960px)').matches) {
    //     shuffleHovers.forEach(btn => {
    //         btn.addEventListener("mouseenter", shuffleAnimation);
    //     })
    // }
}
// End SHUFFLE HOVER ANIMATION

// --- POSTS SLIDER ---
const latestPosts = Array.from(document.querySelectorAll('.latest-posts'));
if (latestPosts.length > 0) {
    latestPosts.forEach(sl => {
        if (sl.querySelector('.swiper')) {
            new Swiper(sl.querySelector('.swiper'), {
                slidesPerView: 3.5,
                spaceBetween: 16,
                slidesPerGroup: 3,
                // loop: true,
                speed: 1000,
                pagination: {
                    el: sl.querySelector('.latest-posts__counter'),
                    type: 'fraction'
                },
                breakpoints: {
                    0: {
                        slidesPerView: 2.2,
                        slidesPerGroup: 2
                    },
                    641: {
                        slidesPerView: 3.2,
                        slidesPerGroup: 3,
                    }, 
                    961: {
                        slidesPerView: 3.5,
                        slidesPerGroup: 3
                    }
                }
            })
        }
    })
}

// --- USER ENTRIES ---
if (document.querySelector('.user-nav--user')) {
    const userNav = document.querySelector('.user-nav--user');
    const mobileUserNav = document.querySelector('.mobile-menu__user-nav');

    fetch('https://app.viralsweep.com/api/entries/202806', {
        headers: {
            'x-api-key': 'f9924c2a3330970aecef85d3e96408adda49b53b7e883b11_52700u'
        }
    }).then(r => r.json())
    .then(r => {
        const { entries } = r;
        const currentUser = entries.find(u => u.email === userNav.dataset.email);
        if (currentUser) {
            const totalEntries = currentUser.entries_total;
            if (Number.parseInt(totalEntries) > 0) {
                if (userNav.querySelector('.user__entries')) userNav.querySelector('.user__entries').textContent = `${totalEntries} entries`;
                if (mobileUserNav.querySelector('.user__entries'))  mobileUserNav.querySelector('.user__entries').textContent = `${totalEntries} entries`;
            } else {
                if (userNav.querySelector('.user__entries')) userNav.querySelector('.user__entries').textContent = `0 entries`;
                if (mobileUserNav.querySelector('.user__entries')) mobileUserNav.querySelector('.user__entries').textContent = `0 entries`;
            }
        } else {
            if (userNav.querySelector('.user__entries')) userNav.querySelector('.user__entries').textContent = `0 entries`;
            if (mobileUserNav.querySelector('.user__entries')) mobileUserNav.querySelector('.user__entries').textContent = `0 entries`;
        }
    }).catch(e => {
        console.log(e);
        if (userNav.querySelector('.user__entries')) userNav.querySelector('.user__entries').textContent = `0 entries`;
        if (mobileUserNav.querySelector('.user__entries')) mobileUserNav.querySelector('.user__entries').textContent = `0 entries`;
    })
}

// --- HERO SOUNTDOWN ---
if (document.querySelector('.hero')) {
    const hero = document.querySelector('.hero'); 
    const counter = hero.querySelector('.counter'); {
        if (counter && counter.dataset.countdown) {
            let futuredate = new Date(counter.dataset.countdown.replace(/\./g, "/"));
           
            if (!isNaN(futuredate)) {

                futuredate = futuredate.getTime();
                const outputHours = counter.querySelector('.counter__item--hours');
                const outputDays = counter.querySelector('.counter__item--days');
                const outputMinutes = counter.querySelector('.counter__item--minutes');
                const outputSeconds = counter.querySelector('.counter__item--seconds');

                function convertMs(ms) {
                    const second = 1000;
                    const minute = second * 60;
                    const hour = minute * 60;
                    const day = hour * 24;
                
                    const days = Math.floor(ms / day);
                    const hours = Math.floor((ms % day) / hour);
                    const minutes = Math.floor(((ms % day) % hour) / minute);
                    const seconds = Math.floor((((ms % day) % hour) % minute) / second);
                
                    return { days, hours, minutes, seconds };
                }
                
                const addLeadingZero = (value, amount = 2) => {
                    return value.toString().padStart(amount, "0");
                }

                const timerCalc = () => {
                    const timerId = setInterval(() => {
                        const currentDate = new Date().getTime();
                        const differenceInTime = convertMs(futuredate - currentDate);
                        
                        outputHours.textContent = addLeadingZero(differenceInTime.hours)
                        outputDays.textContent = addLeadingZero(differenceInTime.days, 3);
                        outputMinutes.textContent = addLeadingZero(differenceInTime.minutes);
                        outputSeconds.textContent = addLeadingZero(differenceInTime.seconds);
                    }, 1000);
                }

                timerCalc();

                // document.addEventListener("DOMContentLoaded", timerCalc)
            }
            
        }
    }
}


// -- AUTH

// class Toggler {
//     constructor(toggleBlock, pageState, selector) {
//       this.toggleMode = toggleBlock;
//       this.state = 'left';
//       this.pageState = pageState;
//       this.pageSelector = selector;
//     }
//     setState(newState, pageNewState) {
//       this.toggleMode.classList.remove(this.state);
//       this.state = newState;
//       this.toggleMode.classList.add(newState);
//       document.querySelector(`${this.pageSelector}${this.pageState}`).classList.add('hide');
//       this.pageState = pageNewState;
//       document.querySelector(`${this.pageSelector}${pageNewState}`).classList.remove('hide');
//     }
//     init() {
//       this.toggleMode.addEventListener('click', (e) => {
//         if (
//           !e.target.classList.contains(`[data-toggler="${this.state}"]`) &&
//           !e.target.closest(`[data-toggler="${this.state}"]`) &&
//           e.target.classList.contains('toggle-mode__selection')
//         ) {
//           this.setState(e.target.dataset.toggler, e.target.dataset.page);
//         }
//       });
//     }
//   }
//   const autToggler = document.querySelector('.toggle-mode--auth');

//   if (autToggler) {
//     new Toggler(autToggler, 'sign-up', '.auth__content--').init();
//     const resetLink = document.querySelector('.reset-link');
//     resetLink.addEventListener('click', (e) => {
//       e.preventDefault();
//       autToggler.classList.add('hide');
//       Array.from(document.querySelectorAll('.auth__content')).forEach((c) => c.classList.add('hide'));
//       document.querySelector('.auth__content--reset').classList.remove('hide');
//       document.querySelector('#resetPassword').addEventListener('submit', (e) => {
//         e.preventDefault();
//         document.querySelector('.auth__content--reset').classList.add('hide');
//         document.querySelector('.auth__content--sent').classList.remove('hide');
//       });
//     });

//     const userToggler = document.querySelector('.toggle-mode--user');
//     if (userToggler) {
//       new Toggler(userToggler, 'account', '.user-frame__content--').init();
//     }
// }
// // End TOGGLE MODES

// const editBtns = Array.from(document.querySelectorAll('.account__edit-btn'));
// if (editBtns.length > 0) {
// editBtns.forEach((btn) => {
//   btn.addEventListener('click', (e) => {
//     e.preventDefault();
//     e.target.closest('.account__block').classList.toggle('editable');
//   });
// });
// }
// const oddAccountBtns = Array.from(document.querySelectorAll('.account__btn'));
// if (oddAccountBtns.length > 0) {
// oddAccountBtns.forEach((btn) => [
//   btn.addEventListener('click', (e) => {
//     e.preventDefault();
//     e.target.closest('.account__block').classList.toggle('updatable');
//   }),
// ]);
// }
// Array.from(document.querySelectorAll('.account__back-btn')).forEach((cancelbtn) =>
// cancelbtn.addEventListener('click', (e) => {
//   e.preventDefault();
//   e.target.closest('.account__block').classList.remove('editable', 'updatable');
// })
// );
// End ACCOUNT



// document.querySelector('#customer_login').addEventListener("submit", e => {
//     e.preventDefault();
// })